<template>
  <footer class="page-footer slds-grid slds-wrap slds-grid_align-center slds-p-top_x-large slds-p-horizontal_large  slds-align_absolute-center" style="padding:0px;">
      <div class="slds-col slds-shrink slds-m-bottom_small" style="width:100%;margin-bottom:0px;padding-bottom:0px;">
        <img src="/poweredbyq-light.png" width="254px" height="39px"/>
      </div>
  </footer>
</template>

<script>
  export default {
    name: 'PageFooter',
  }
</script>
<style>
  .page-footer{
      background: #063C6C;
      width: 100%;
      height: 120px;
  }
</style>